//import { MatSidenav } from '@angular/material/sidenav';
//import { GlobalsService } from './@core/services/globals.service';
import { Component, AfterViewInit, Renderer2, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
//import { fadeInAnimation } from './animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss','./@theme/styles/navbar.scss','./@theme/styles/loading.scss'],
  animations: [
    // fadeInAnimation
    // animation triggers go here
  ],
  // host: { '[@fadeInAnimation]': '' }

})
export class AppComponent implements OnInit {
  
  title = 'ieee-sudan';
  showLoading=true;
  showPage=false

  menu_icon_path = 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z';

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  constructor() {
    
  }

  ngOnInit() {
    setTimeout(() => { this.showLoading=false;
    this.showPage=true;
    },2000);
  }

// setTimeout(() => 
// {
//     this.showPage=true;
// },
// 1000);
//   }
  

}